import React from 'react';
import { Text } from 'components/typography';
import { NavLink } from 'components/links';
import { MenuContainer } from '../MenuContainer';

export const NavMenu = ({ isDisabled, isSelected, icon, text, to }) => (
  <NavLink
    to={to}
  >
    <MenuContainer
      isDisabled={isDisabled}
      isSelected={isSelected}
      icon={icon}
    >
      <Text
        isFaded={isDisabled}
        variant="sideBar.navMenu"
      >
        {text}
      </Text>
    </MenuContainer>
  </NavLink>
);
